import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CompanyForm from './forms/CompanyForm';
import FormSidebar from './forms/FormSidebar';
import useCompanyForm from '../hooks/useCompanyForm';

interface CompanyRegistrationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CompanyRegistrationModal: React.FC<CompanyRegistrationModalProps> = ({ isOpen, onClose }) => {
  const {
    formData,
    errors,
    isSubmitting,
    handleInputChange,
    handleSubmit
  } = useCompanyForm();

  const handleFormSubmit = async (e: React.FormEvent) => {
    await handleSubmit(e, onClose);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="uk-modal-full"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
            style={{
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              borderRadius: '15px',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              maxWidth: '1200px',
              margin: '20px auto',
              maxHeight: '90vh',
              overflow: 'auto'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="uk-modal-close-default" 
              type="button" 
              onClick={onClose}
              style={{
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                cursor: 'pointer',
                position: 'absolute',
                top: '20px',
                right: '20px',
                zIndex: 1
              }}
            >
              ×
            </button>
            
            <div className="uk-container uk-container-small">
              <div className="uk-grid uk-grid-large uk-flex-middle" data-uk-grid>
                <div className="uk-width-2-3@m">
                  <div className="formulario-content">
                    <h2 className="uk-heading-medium uk-margin-medium-bottom">Registro de Empresa</h2>
                    <p className="uk-text-lead uk-margin-medium-bottom">
                      Completa el formulario con los datos de tu empresa para comenzar a ofrecer tus servicios
                    </p>
                    
                    <CompanyForm
                      formData={formData}
                      errors={errors}
                      isSubmitting={isSubmitting}
                      onInputChange={handleInputChange}
                      onSubmit={handleFormSubmit}
                    />
                  </div>
                </div>
                
                <div className="uk-width-1-3@m">
                  <FormSidebar />
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompanyRegistrationModal;
